<template>
  <div class="customer">
    <img
      class="qrcode"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/98ab0328f173a6b25cb60a0424f374b5.jpg"
      alt=""
    />
    <div class="btn" @click="bindClick">添加客服</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      urlScheme: '',
      wechatUrl:
        'https://work.weixin.qq.com/ca/cawcde4424ad3a1ba9?customer_channel=qywx_ca:105410285'
    }
  },
  created() {},
  mounted() {},
  methods: {
    bindClick() {
      location.href = this.wechatUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.customer {
  min-height: 100vh;
  background-color: #fff;
  .qrcode {
    width: 100%;
    object-fit: contain;
  }
  .btn {
    position: relative;
    z-index: 1;
    margin: -10px auto 0px;
    width: 320px;
    height: 40px;
    font-size: 16px;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    background-color: rgb(151, 133, 253);
    text-align: center;
    border-radius: 10px;
  }
}
</style>
